import React from "react";

import {
  FaPlus,
  FaTimes,
} from "react-icons/fa";

import AddMovimientoForm from "./AddMovimientoForm";

const AddMovimiento = ({
  show,
  setShow,
}) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="mov2-add-row">
        <button
          type="button"
          className={
            show
              ? "mov2-add-button mov2-add-button-cancel"
              : "mov2-add-button"
          }
          onClick={handleShow}
        >
          {show ? (
            <>
              <FaTimes />
              Cancelar
            </>
          ) : (
            <>
              <FaPlus />
              Nuevo movimiento
            </>
          )}
        </button>
      </div>

      {show && (
        <div className="mov2-add-form">
          <AddMovimientoForm
            setShow={setShow}
          />
        </div>
      )}
    </>
  );
};

export default AddMovimiento;